import { Cell } from '@/shared/ui/primitives';
import type { FC } from 'react';

import type { ClientDetailPass } from '@/types';
import { formatDateForDisplay } from '@/shared/lib/calendarDate';
import { getPassMeta } from '@/shared/lib/client';
import { TEST_ID_BUILDERS } from '@/testIds';
import { Pill } from '@/shared/ui';

interface PastDescription {
  label: string;
  subtitle: string;
}

const describePast = (pass: ClientDetailPass): PastDescription => {
  const meta = getPassMeta(pass);

  if (meta?.isOutOfCredits && !meta.isExpired) {
    return {
      label: 'No credits',
      subtitle: `Started ${formatDateForDisplay(pass.startsAt)}`,
    };
  }

  if (pass.endsAt) {
    return {
      label: 'Expired',
      subtitle: `Ended ${formatDateForDisplay(pass.endsAt)}`,
    };
  }

  return {
    label: 'Expired',
    subtitle: `Started ${formatDateForDisplay(pass.startsAt)}`,
  };
};

interface PastPassListItemProps {
  pass: ClientDetailPass;
  onClick: (pass: ClientDetailPass) => void;
}

export const PastPassListItem: FC<PastPassListItemProps> = ({ pass, onClick }) => {
  const description = describePast(pass);

  return (
    <Cell
      data-testid={TEST_ID_BUILDERS.passByName(pass.name)}
      leading={<span aria-hidden="true">•</span>}
      trailing={<Pill tone="neutral">{description.label}</Pill>}
      subtitle={description.subtitle}
      onClick={() => onClick(pass)}
    >
      {pass.name}
    </Cell>
  );
};
